import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const LoginContainer = styled.div``;
export const LoginWelcomeText = styled.div`
  width:100%;
  text-align: center;
  color:white;
  font-size: ${pxToRem('14px')}
  line-height: 1.57;
  font-weight: 600;
  padding-top: ${pxToRem('67px')};
  padding-bottom:${pxToRem('33px')};
`;

export const InputsSection = styled.div`
  min-height: ${pxToRem('100px')};
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  height: 100%;
`;

export const RowForm = styled.div`
  padding-top: ${pxToRem('32px')};

  ${props =>
    props.managePersonalData &&
    css`
      & > div {
        height: ${pxToRem('56px')};
      }
    `}

    ${props =>
      props.editingPersonalData &&
      css`
        display: flex;
        justify-content: center;
        width: 100%;
        & > div {
          width: 100%;
        }
      `}}

  ${props =>
    props.smallerPaddingTop &&
    css`
      padding-top: ${pxToRem('24px')};
    `}
`;

export const RowCentered = styled.div`
  display: flex;
  justify-content: center;
  //z-index: 999999;
`;

export const ForgotSection = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: ${pxToRem('18px')};
  text-transform: uppercase;
  color: ${props => props.theme.colors.white};
  z-index: 10;
`;
export const ForgotText = styled.div`
  width: fit-content;

  > span:hover {
    cursor: pointer;
  }
`;

export const SubmitWrapper = styled.div`
  padding-top: ${pxToRem('56px')};
  text-transform: uppercase;
  // z-index: 10;
`;
export const RememberMeSection = styled.div`
  padding-top: ${pxToRem('42px')};
`;
